export const toTitleCase = (str = "") =>
  str.replace(/\w\S*/g, (txt) =>
    txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );

export const normalize = (str = "") =>
  str.trim().replace(/\s+/g, " ").toLowerCase();

export const normalizeNoSpaces = (str = "") =>
  str.trim().replace(/\s+/g, "").toLowerCase();